export default {
  state: {},
  mutations: {}
};
